import { useContext } from 'react';
import { BucketListContext } from 'src/contexts/BucketListProvider';

const useBucketList = () => {
  return useContext(BucketListContext);
};

export default useBucketList;
